import type { CollectionState, CollectionAdapter } from '@common/adapters/collections';
import type { EduCourse } from '@common/types/edu-course.type';

import { createReducer, on } from '@ngrx/store';
import { createCollectionAdapter } from '@common/adapters/collections';

import EduCoursesActions from './edu-courses.actions';

export const EDU_COURSES_COLLECTIONS_FEATURE_KEY = 'eduCourses';

export type EduCoursesCollectionState = CollectionState<EduCourse>;

export const eduCoursesAdapter: CollectionAdapter<EduCourse> = createCollectionAdapter<EduCourse>();

export const eduCoursesCollectionReducer = createReducer<EduCoursesCollectionState>(
    eduCoursesAdapter.getInitialState(),
    on(EduCoursesActions.loadCollectionRequest, (state: EduCoursesCollectionState) =>
        eduCoursesAdapter.loadCollectionRequest(state)
    ),
    on(EduCoursesActions.loadCollectionSuccess, (state: EduCoursesCollectionState, { courses }) =>
        eduCoursesAdapter.loadCollectionSuccess(courses, state)
    ),
    on(EduCoursesActions.loadCollectionFailure, (state: EduCoursesCollectionState, { error }) =>
        eduCoursesAdapter.loadCollectionFailure(error, state)
    )
);
